module.exports = __webpack_public_path__ + "static/img/6.cc31ada.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/6.png
// module id = S4vF
// module chunks = 0